export const GANTT_CHART_ROW_HEIGHT = 50
export const GANTT_CHART_ITEM_HEIGHT = 35
export const NOW_INDICATOR_REFRESH_INTERVAL_MS = 60 * 1000
